import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';

import { setIframeView } from '@/redux/user/actions';
import { selectUser } from '@/redux/user/selectors';

const useIframeStyles = () => {
  const [URLSearchParams] = useSearchParams();
  const iframe = URLSearchParams.get('iframe') === 'true';
  const source = useSelector(selectUser)?.metadata?.source;
  const dispatch = useDispatch();
  useEffect(() => {
    if (iframe || source === 'iframe') {
      dispatch(setIframeView(true));
      // The HGS brand colors live in globals.css under [data-brand='hgs'].
      document.documentElement.setAttribute('data-brand', 'hgs');
    }
  }, [dispatch, iframe, source]);
};

export default useIframeStyles;
